var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isloggedin)?_c('UserTools'):_c('LoginBlock',{attrs:{"title":_vm.title,"block":_vm.block}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }